/** Chuỗi của màn Token AI ở cổng tenant (ADR-0123). Chỉ nói token Fox: cấm nhắc tới cách quy đổi hay giá nhà cung cấp. */
export const viManTokenAi = {
  manTokenAi: {
    vuot: 'Vượt {{so}} token',
    theSuDung: 'Mức sử dụng',
    theHanMuc: 'Hạn mức',
    theNapToken: 'Nạp token',
    dauVao: 'Đầu vào',
    dauRa: 'Đầu ra',
    tong: 'Tổng',
    rong: 'Chưa có lượt dùng AI trong khoảng này',
    theoNgay: 'Token Fox theo ngày',
    theoNgayNhan: 'Token Fox đầu vào và đầu ra mỗi ngày trong {{so}} ngày gần nhất',
    chonKhoang: 'Chọn khoảng ngày',
    soNgay: '{{so}} ngày',
    phanTich: 'Theo tháng',
    chonThang: 'Chọn tháng',
    theoTinhNang: 'Theo tính năng',
    theoPhongBan: 'Theo phòng ban',
    theoNguoiDung: 'Người dùng dùng nhiều',
    theoModel: 'Theo model',
    khongGanTinhNang: 'Tính năng khác',
    khongGanDonVi: 'Chưa thuộc phòng ban',
    khongGanNguoi: 'Chạy tự động, không gắn người dùng',
    khac: 'Khác ({{so}} mục)',
    soLuot: 'Số lượt',
    moTaDong: '{{ten}}: đầu vào {{vao}}, đầu ra {{ra}}, tổng {{tong}} token Fox, {{luot}} lượt',
    dongSo: 'Vào {{vao}} · Ra {{ra}} · {{luot}} lượt',
    phamViDonVi: 'Phòng ban',
    phamViNguoi: 'Người dùng',
    hanhDongChan: 'Chặn',
    hanhDongCanhBao: 'Chỉ cảnh báo',
    chuKyNgay: 'Ngày',
    chuKyTuan: 'Tuần',
    chuKyThang: 'Tháng',
    moiTinhNang: 'Mọi tính năng',
    moiPhamVi: 'Mọi phạm vi',
    locPhamVi: 'Lọc theo phạm vi',
    giaiThich:
      'Hạn mức là trần riêng trong gói, không chia phần: tổng các hạn mức được vượt gói và gói vẫn là trần cao nhất. Hạn mức của phòng ban áp cả phòng con.',
    themHanMuc: 'Thêm hạn mức',
    suaHanMuc: 'Sửa hạn mức',
    xoaHanMuc: 'Xoá hạn mức',
    luuThayDoi: 'Lưu thay đổi',
    dangLuu: 'Đang lưu...',
    cotPhamVi: 'Phạm vi',
    cotDoiTuong: 'Đối tượng',
    cotTinhNang: 'Tính năng',
    cotChuKy: 'Chu kỳ',
    cotDaDung: 'Đã dùng / giới hạn',
    cotHanhDong: 'Hành động',
    cotBat: 'Bật',
    bangCaption: 'Hạn mức token Fox theo phòng ban và người dùng',
    daDungTren: '{{daDung}} / {{gioiHan}}',
    moLai: 'Mở lại ngày {{ngay}}',
    doiTuongKhongCon: 'Không còn trong tổ chức',
    batNhan: 'Bật hạn mức của {{ten}}',
    rongHanMuc: 'Chưa có hạn mức nào',
    rongHanMucMo: 'Đặt trần token Fox cho một phòng ban hoặc một người để tránh dùng hết gói sớm.',
    rongLoc: 'Không có hạn mức nào khớp bộ lọc',
    chonPhongBan: 'Chọn phòng ban',
    soToken: 'Số token Fox',
    goiYChan: 'Hết hạn mức thì lời gọi AI trong phạm vi này dừng tới khi mở lại.',
    goiYCanhBao: 'Vẫn cho dùng; quản trị viên nhận thông báo khi chạm 80% và 100%.',
    loiChonPhongBan: 'Chọn một phòng ban.',
    loiChonNguoi: 'Chọn một người dùng.',
    loiSoTrong: 'Nhập số token Fox.',
    loiSoSai: 'Nhập số nguyên, ví dụ 20.000.',
    loiSoQuaLon: 'Số quá lớn, tối đa 1.000.000.000.000.',
    loiSoKhong: 'Nhập số lớn hơn 0.',
    daTao: 'Đã thêm hạn mức.',
    daLuu: 'Đã lưu thay đổi.',
    daXoa: 'Đã xoá hạn mức.',
    daBat: 'Đã bật hạn mức.',
    daTat: 'Đã tắt hạn mức.',
    xoaTieuDe: 'Xoá hạn mức của {{ten}}?',
    xoaThan: 'Đối tượng này không còn bị giới hạn bởi hạn mức này, gói của tổ chức vẫn áp. Không hoàn tác được.',
    dashboardCanhBao: 'Tổ chức đã dùng {{so}}% hạn mức token AI tháng này.',
    dashboardVuot: 'Tổ chức đã dùng quá hạn mức token AI tháng này.',
    canhBaoVuot:
      'Tổ chức đã dùng quá hạn mức token AI tháng này. Khi hết phần còn lại, các tính năng AI tạm dừng tới ngày {{ngay}}; cần thêm thì gửi yêu cầu ở thẻ Nạp token.',
    dashboardXem: 'Xem Token AI',
  },
} as const;
